import React, { useState } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import { withStyles, Dialog, Tooltip, IconButton } from "@material-ui/core";
import * as actions from "../../sc-core/Auth/store/authActions";
import OpenIDConnectForm from './OpenIDConnectForm';
import OpenID from '../../sc-utilities/images/Openid.svg';


const styles = theme => ({
    btn: {
        textAlign: 'right', marginLeft: '50%', marginBottom: '0.3rem'
    },
    formControl: {
        marginTop: theme.spacing(5),
        width: "100%",
        marginBottom: '5px',
    },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '15vh',
        minWidth: '70vh'
    },
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

let openIDInitialValues = {
    Namespace: ''
};

const OpenIDConnect = props => {
    const { classes, onOpenIDConnect, translations } = props;

    const [open, setOpen] = useState(false);

    const handleOpenToggle = () => {
        setOpen(!open);
    };

    let openIDFormSettings = {
        Validation: {
            Namespace: Yup.string().required("Required"),
        },
        ButtonSubmit: {
            Title: translations["submit"] || "Submit",
            Color: "primary"
        },
    };

    const handleOpenIDConnect = async (data) => {
        data['ClientType'] = "dashboard_client";
        data['ClientVersion'] = "2.8";
        let res = await onOpenIDConnect(data);
        if (res.data.result.data.redirectURL) {
            window.location.href = res.data.result.data.redirectURL;
        }
    };

    return (
        <>
            <Tooltip title={translations["login_with_openid"] || "Log in with OpenID Connect"}>
                <span>
                    <IconButton color="inherit" onClick={handleOpenToggle} onClose={handleOpenToggle}>
                        <img width="24" src={OpenID} alt="OpenID" />
                    </IconButton>
                </span>
            </Tooltip>
            <Dialog open={open} onClose={handleOpenToggle} classes={{ paper: classes.dialogPaper }}>
                <OpenIDConnectForm
                    translations={translations}
                    handleSubmit={handleOpenIDConnect}
                    initialValues={openIDInitialValues}
                    formSettings={openIDFormSettings} />
            </Dialog>
        </>
    );
}

const mapStateToProps = state => {
    return { translations: state?.translate?.translations?.activeTranslations || {} }
};

const mapDispatchToProps = dispatch => {
    return { onOpenIDConnect: params => dispatch(actions.openIDConnect(params)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(OpenIDConnect));
